import React, { lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LangProvider } from "./contexts/LangContext";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import { usePageTracking } from "./hooks/usePageTracking";

const About = lazy(() => import("./pages/About"));
const Contact = lazy(() => import("./pages/Contact"));
const Locations = lazy(() => import("./pages/Locations"));
const LocationDetail = lazy(() => import("./pages/LocationDetail"));
const AdminLogin = lazy(() => import("./pages/AdminLogin"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard"));
const LoyaltyPage = lazy(() => import("./pages/LoyaltyPage"));

const Shell = ({ children }) => (
  <div className="App">
    <Header />
    <main>{children}</main>
    <Footer />
  </div>
);

function PageTracker() {
  usePageTracking();
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <LangProvider>
        <AuthProvider>
          <BrowserRouter>
            <PageTracker />
            <Toaster richColors position="top-center" />
            <Routes>
              <Route path="/" element={<Shell><Home /></Shell>} />
              <Route path="/despre" element={<Suspense fallback={null}><Shell><About /></Shell></Suspense>} />
              <Route path="/contact" element={<Suspense fallback={null}><Shell><Contact /></Shell></Suspense>} />
              <Route path="/locatii" element={<Suspense fallback={null}><Shell><Locations /></Shell></Suspense>} />
              <Route path="/locatii/:slug" element={<Suspense fallback={null}><Shell><LocationDetail /></Shell></Suspense>} />
              {/* <Route path="/fidelitate" element={<Suspense fallback={null}><LoyaltyPage /></Suspense>} /> */}
              <Route path="/admin/login" element={<Suspense fallback={null}><AdminLogin /></Suspense>} />
              <Route path="/admin" element={<Suspense fallback={null}><AdminDashboard /></Suspense>} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </LangProvider>
    </HelmetProvider>
  );
}

export default App;
